import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { editJobDetailsEndpoint } from '../../../common/endpoints';

export const editJobDetailsApi = createApi(editJobDetailsEndpoint, 'PUT');

const EditJobDetails = createSlice({
  name: 'EditJobDetails',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(editJobDetailsApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editJobDetailsApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(editJobDetailsApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default EditJobDetails.reducer;